import { render, staticRenderFns } from "./TreeFolders.vue?vue&type=template&id=5e95dac3"
import script from "./TreeFolders.vue?vue&type=script&lang=js"
export * from "./TreeFolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports